<template>
  <div>
  <div class="overlay"></div>
  <div class="modal_fixed">
    <div class="new_achievement_box modal_cont" id="new_achievement_modal">

      <img src="static/images/store/icon-close-back-popup.svg" class="btn_close" @click="$emit('close')">

      <h1>{{ getTranslations.home_modals_achievements_title }} {{ achievementInfo.achievementLevelName }}</h1>
      <p>{{ getTranslations.home_modals_achievements_progress_so_close }}<br> {{ getTranslations.home_modals_achievements_answer }} {{ achievementInfo.threshold }} {{ getTranslations.home_modals_achievements_progress_more_questions }} "{{ achievementInfo.achievementLevelName }}"</p>
      <img :src="achievementInfo.image" class="icon_achievement">

      <div class="progress_bg">
        <div class="progress_text">{{ achievementInfo.percentage }}%</div>
        <div class="progressbar">
          <div class="progressbar__bar" :data-percent="achievementInfo.percentage"></div>
        </div>
      </div>

      <h2>{{ getTranslations.home_modals_achievements_rewarded}}</h2>
      <achievement-reward :achievement-info="achievementInfo" :disable-play="true"/>
    </div>
  </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AchievementReward from '@/components/home/modals/achievements/AchievementReward';
import { profileBar } from '@/common/jQuery';

export default {
  name: 'achievement-in-progress',
  components: {
    AchievementReward,
  },
  props: {
    achievementInfo: Object,
  },
  mounted() {
    /* eslint-disable */
    profileBar();
    $('.progressbar__bar').each(function (t, e) {
      var n = $(e).data("percent");
      $(e).width(n + "%");
    });
  },
  updated() {
    profileBar();
  },
  computed: {
    remaining() {
      const { percentage, threshold } = this.achievementInfo;
      return Math.floor(threshold - ((percentage * threshold) / 100));
    },
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/achievements/AchievementInProgress.vue